[
    {
     "id": 1,
     "question": "What is the Infrastructure Scenario Modelling Tool?",
     "answer": "The Infrastructure Scenario Modelling Tool is an interactive platform built by Infrastructure Australia. It allows users to test “what if” scenarios by adjusting project data variables such as timelines, phases, and project mix. By exploring multiple scenarios, users can observe and compare the cascading impacts of differing alternatives on baselines and forecasts, leading to better investment decisions and outcomes."
    },
    {
     "id": 2,
     "question": "What data and assumptions support the Infrastructure Scenario Modelling Tool?",
     "answer": "The scenario modelling tool is using the same assumptions used in our Market Capacity Report. You can find the detailed methodology in appendix"
    },
    {
     "id": 3,
     "question": "Does everyone have the same view/access?",
     "answer": "No. The Scenario Modelling platform currently support 3 user categories. Internal Infrastructure Australia users have the capability to view all data provided to IA or accumulated by IA. Federal users will have access to federal supplied data as well as data collected by IA. Jurisdiction user are granted access to data provided by their respective jurisdictions, federal data pertinent to their state, and IA collected relevant to their state."
    },
    {
     "id": 4,
     "question": "What types of scenarios can I create?",
     "answer": "You can create any scenario by removing/ modifying existing pipeline or adding new projects into pipeline. The tool will forecast demand based your revised pipeline compare that to the current baseline."
    },
    {
    "id": 5,
    "question": "What is the output format/content for a scenario?",
    "answer": "The output of a scenario is displayed as graphs and is located within the Output Tab of the platform."
    },
    {
    "id": 6,
    "question": "Can I share scenarios/outputs with unregistered /non-government users?",
    "answer": "The platform is currently not supporting sharing of scenario. However, that is on our development roadmap."
    },
    {
      "id": 7,
      "question": "What are the Terms of Use that apply?",
      "answer": "The Deed of Agreement between IA and each State / Territory covers the terms under which use of this site is agreed."
    }
   ]
